import React from "react";
class Button extends React.Component {
    handleClick = e => {
        e.preventDefault();
        this.props.onClick();
    };

    render() {
        return this.props.primary === true ? (
            <button type="button" onClick={this.handleClick} disabled={this.props.btnStatus} style={{ float: "right" }}>
                {this.props.text}
            </button>
        ) : (
            <button type="button" onClick={this.handleClick}>
                {this.props.text}
            </button>
        );
    }
}

Button.defaultProps = {
    text: "Submit",
    className: undefined,
    btnStatus: "",
    onClick: () => {}
};

export default Button;
